import { createReducer } from "@reduxjs/toolkit";
import { WorkspaceLayoutConstants } from "./constants";
import type { IWorkspaceLayoutState } from "./interface";
import * as WorkspaceLayoutActions from "./actions";

const initialState: IWorkspaceLayoutState = {
  layout: {},
  syncedLayout: {}
};

export const workspaceLayoutReducer = createReducer(initialState, {
  [WorkspaceLayoutConstants.SET_LAYOUT]: (
    draftState,
    action: ReturnType<typeof WorkspaceLayoutActions.setWorkspaceLayout>
  ) => {
    draftState.layout = action.payload.layout;
  },
  [WorkspaceLayoutConstants.MERGE_LAYOUT]: (
    draftState,
    action: ReturnType<typeof WorkspaceLayoutActions.mergeWorkspaceLayout>
  ) => {
    draftState.layout = {
      ...draftState.layout,
      ...action.payload.layout
    };
  },
  [WorkspaceLayoutConstants.SET_SYNCED_LAYOUT]: (
    draftState,
    action: ReturnType<typeof WorkspaceLayoutActions.setWorkspaceSyncedLayout>
  ) => {
    draftState.syncedLayout = action.payload.syncedLayout;
  },
  [WorkspaceLayoutConstants.MERGE_SYNCED_LAYOUT]: (
    draftState,
    action: ReturnType<typeof WorkspaceLayoutActions.mergeWorkspaceSyncedLayout>
  ) => {
    draftState.syncedLayout = {
      ...draftState.syncedLayout,
      ...action.payload.syncedLayout
    };
  }
});
